import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import type { AxiosInstance, AxiosPromise } from 'axios';
import { JobCommoditySearchRequest, JobCommoditySearchResponse } from './JobCommodityService.types';

export class JobCommodityService implements BaseRequestEndpoints {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search({ queryParams, routeParams }: JobCommoditySearchRequest) {
    return this.instance.get<JobCommoditySearchResponse>(`jobs/${routeParams.jobId}/commodities`, {
      params: queryParams,
    });
  }

  create(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  getById(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  update(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  delete(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }
}
